import {
  collection, getDocs, addDoc, doc, deleteDoc,
  query, orderBy, Timestamp
} from "firebase/firestore";
import { db } from "../config/firebase";
import DOMPurify from 'dompurify';

export const getAllMessages = async () => {
  try {
    const messagesQuery = query(
      collection(db, "messages"),
      orderBy("createdAt", "desc")
    );

    const messagesSnapshot = await getDocs(messagesQuery);
    return messagesSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt.toDate()
    }));
  } catch (error) {
    console.error('Error loading messages:', error);
    throw error;
  }
};

export const createMessage = async (messageData) => {
  try {
    // Adapted for ContactPage data template
    const sanitizedMessage = DOMPurify.sanitize(messageData.message || '');
      const newMessage = {
          name: messageData.name,
          email: messageData.email,
          phone: messageData.phone,
          subject: messageData.subject,
          message: sanitizedMessage,
          createdAt: Timestamp.fromDate(new Date())
      };

    await addDoc(collection(db, 'messages'), newMessage);
  } catch (error) {
    console.error('Error creating message:', error);
    throw error;
  }
};

export const deleteMessage = async (messageId) => {
  try {
    if (!messageId) {
      throw new Error('Message ID is required');
    }
    await deleteDoc(doc(db, 'messages', messageId));
    return { success: true };
  } catch (error) {
    console.error('Error deleting message:', error);
    return { success: false, error };
  }
};
